// extracted by mini-css-extract-plugin
export default {"fixed-height":"RichTextEditor_fixed-height__1b8e9","email-body":"RichTextEditor_email-body__c3jy4"};